"use client"

import React, {useEffect, useState} from 'react';
import GermanHeader from './header/german';
import '../../styles/2-layout/_3-navigation.scss';
import DefaultHeader from "./header/default";

export default function Header () {
    const [german, setGerman] = useState('unset');
    const [domLoaded, setDomLoaded] = useState(false);

    useEffect(() => {
        setDomLoaded(true);
    }, []);

    let windowHref = '';
    if (typeof window !== 'undefined') {
        windowHref = window.location.href;
    }

    if (german === 'unset' && (windowHref.includes('sonshaar.de') || windowHref.includes('/de/'))) {
        setGerman('true');
    } else if (german === 'unset') {
        setGerman('false');
    }

    return <div className="header-wrapper-container">
        {german === 'true' && domLoaded && (
            <GermanHeader />
        )}
        {german === 'false' && domLoaded && (
            <DefaultHeader />
        )}
        {german === 'unset' && domLoaded && (
            <div>
                Loading...
            </div>
        )}
    </div>
}